var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hello"},[_c('a-layout',[_c('a-layout-content',[_c('div',{staticStyle:{"padding-top":"4%"}},[_c('router-view')],1)]),_c('a-layout-footer',[_c('footerHome')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }